// In production (Docker/nginx) this is empty — requests go to /api/* on the same host.
// In local dev, set REACT_APP_API_URL=http://localhost:8000 in .env.development.local
const API_BASE = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : "";

export async function rawSql(sql) {
  const res = await fetch(`${API_BASE}/api/admin/d8f3a291/sql`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sql }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || "Query failed");
  }
  return res.json();
}

export async function getTeam(slug) {
  const res = await fetch(`${API_BASE}/api/team/${slug}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("Failed to load team");
  return res.json();
}

export async function getStats() {
  const res = await fetch(`${API_BASE}/api/status`);
  if (!res.ok) return null;
  return res.json();
}

export async function createShare(messages, result) {
  const res = await fetch(`${API_BASE}/api/share`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ messages, result }),
  });
  if (!res.ok) throw new Error("Failed to create share link");
  return res.json();
}

export async function getShare(id) {
  const res = await fetch(`${API_BASE}/api/share/${id}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("Failed to load shared conversation");
  return res.json();
}

export async function askQuestion(question, history) {
  const res = await fetch(`${API_BASE}/api/query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question, history }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || "Request failed");
  }

  return res.json();
}
